// Was ein Lehrer fuer eine Sitzung waehlen kann. Eine Sitzung = ein Thema.
// kategorien: leer = das Thema hat (noch) keine.
// maxAnzahl: wie viele Aufgaben ein Schueler hoechstens bekommen kann.
import { tasks } from './Tasks'
import { schemata } from './daten'

export const sitzungThemen = [
    {
        id: 'funk',
        label: 'Funkgerät',
        kategorien: [...new Set(tasks.flatMap(t => t.categories))],
        // Funkaufgaben sind eine feste Liste — mehr als vorhanden geht nicht.
        maxAnzahl: tasks.length
    },
    {
        id: 'sprechregeln',
        label: 'Sprechregeln',
        // Die Kategorien sind die Ablaeufe aus daten.js, gefuehrt unter ihrem
        // Namen — so stehen sie im Formular und in der Klassenansicht.
        kategorien: schemata.map(s => s.name),
        maxAnzahl: 20
    }
]

// Wie viele Funkaufgaben in den gewaehlten Kategorien liegen (leer = alle).
export function verfuegbareAnzahl(thema, kategorien) {
    if (thema.id !== 'funk') return thema.maxAnzahl
    if (kategorien.length === 0) return tasks.length
    return tasks.filter(t => t.categories.some(c => kategorien.includes(c))).length
}
